// extracted by mini-css-extract-plugin
export default {"alertWrapper":"AlertMessage_alertWrapper__lrUQb","alertTitle":"AlertMessage_alertTitle__tmSm8","alertIcon":"AlertMessage_alertIcon__uPTVD"};